export const BANKID_INSTANCE_MISMATCH_CODE = 400158;

export const BANKID_INSTANCE_MISMATCH_MESSAGE_KEY =
	"specific:MEMBERSHIP.REGISTRATION.BANKID.INSTANCE_MISMATCH";

export function isBankIdInstanceMismatchError(error: any): boolean {
	const code = error?.data?.errorCode ?? error?.data?.error;
	return code === BANKID_INSTANCE_MISMATCH_CODE;
}
